import React, { Fragment, useEffect, useState } from "react";
import { Step, StepLabel, Stepper } from "@mui/material";
import { navigate } from "gatsby";
import emailjs from "@emailjs/browser";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const Steps = ({ name }) => {
  const [debtValue, setDebtValue] = useState(63000);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [formError, setFormError] = useState({
    debtValue: "",
    liveInTexas: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [values, setValue] = useState({
    debtValue: "",
    liveInTexas: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleSliderChange = (sliderEvent, newValue) => {
    setDebtValue(newValue);
    setValue({
      ...values,
      debtValue: newValue ? newValue : 63000,
    });
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);

    const url = window.location.href;
    const emailData = {
      subject: `Referer: [${url}]`,
      fromName: `ADC ${name} Referer: ${url}`,
      googleUrlParameter: url,
      toName: "there",
      referer: url,
      ...values,
    };

    emailjs
      .send(
        "service_p5cs97s",
        "template_c8tfhst",
        emailData,
        "PvTyuGGKn4qTGC0S7"
      )
      .then(
        (result) => {
          setLoading(false);
          setValue({
            debtValue: "",
            liveInTexas: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
          });
          navigate(name === "WFaaR" ? "/next-step/rr1/" : "/next-step/");
        },
        (error) => {
          setLoading(false);
          console.log(error);
        }
      );
  };
  const handleBeforeUnload = (e) => {
    // Check if any of the input fields are filled
    if (values.debtValue !== "") {
      e.preventDefault();
      e.returnValue = ""; // Required for Chrome
      // setShowAlert(true);
      // Show your custom alert modal here
      // ...
    } else {
      // setShowAlert(false);
    }
  };

  useEffect(() => {
    if (values.debtValue && values.liveInTexas !== "No") {
      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
    // eslint-disable-next-line
  }, [values]);

  useEffect(() => {
    if (values.liveInTexas === "No") {
      navigate("https://affordabledebtconsolidation.com/loans/");
      setStep("redirect");
    }
  }, [values]);

  const activeStep = step - 1;

  return (
    <Fragment>
      <div className="w-full">
        <Stepper
          activeStep={!Number.isNaN(activeStep) ? activeStep : 3}
          alternativeLabel
        >
          <Step key={1}>
            <StepLabel>
              <span className="hidden">1</span>
            </StepLabel>
          </Step>
          <Step key={2}>
            <StepLabel>
              <span className="hidden">2</span>
            </StepLabel>
          </Step>
          <Step key={3}>
            <StepLabel>
              <span className="hidden">3</span>
            </StepLabel>
          </Step>
        </Stepper>
      </div>
      <div className="w-full">
        {step === 1 ? (
          <Step1
            handleSliderChange={handleSliderChange}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            setFormError={setFormError}
            formError={formError}
            debtValue={debtValue}
            setStep={setStep}
            values={values}
            step={step}
          />
        ) : step === 2 ? (
          <Step2
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            setFormError={setFormError}
            formError={formError}
            setStep={setStep}
            values={values}
            step={step}
          />
        ) : step === 3 ? (
          <Step3
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            setFormError={setFormError}
            formError={formError}
            loading={loading}
            setStep={setStep}
            values={values}
            step={step}
          />
        ) : step === "redirect" ? (
          <p className="text-center mt-4 mb-40 text-lg font-bold text-gray-800">
            Redirecting you shortly...
          </p>
        ) : null}
      </div>
    </Fragment>
  );
};

export default Steps;
